// @ts-nocheck
import { FC, useEffect, useState } from "react";
import { BUST_SIZE, inputParameters } from "./constants";
import styles from "./ModelInfo.module.scss";
import MultiDropdown from "../ui/Dropdown/MultiDropdown";
import { Button } from "../ui";
import { DropdownTwo } from "../ui/Dropdown/DropdownTwo";
import { InputPassword } from "../ui/InputPassword/InputPassword";
import { Input } from "../ui/Input/Input";
import { useAppDispatch, useAppSelector } from "../../services/hooks";
import { getAppearance } from "../../api/appearance";
import { IAppearance } from "../../types/appearance";
import { THaircut } from "../../types/haircut";
import { getHaircuts } from "../../api/haircut";
import Loader from "../Loader/Loader";
import { IRequestPatchUser } from "../../types/user";
import { updateUser } from "../../services/slices/user";

export const BlockParameters: FC = () => {
  const [formData, setFormData] = useState(inputParameters);
  const { user } = useAppSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const handleChange = (newValue: string | number | number[], id: string) => {
    setFormData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, value: newValue } : item,
      ),
    );
  };

  const setUserData = useCallback(() => {
    if (user) {
      setFormData((prevData) =>
        prevData.map((item) => {
          switch (item.id) {
            case "height":
              return { ...item, value: user.model?.height || null };
            case "weight":
              return { ...item, value: user.model?.weight || null };
            case "description":
              return { ...item, value: user.model?.description || "" };
            case "brust":
              return {
                ...item,
                value: user.model?.breast
                  ? BUST_SIZE.find((bust) => bust.name === user.model?.breast)
                      ?.id
                  : null,
              };
            case "appearance":
              return {
                ...item,
                value: user.usersAppearances
                  ? user.usersAppearances.map((val) => val.appearanceId) || []
                  : [],
              };
            case "haircut":
              return {
                ...item,
                value: user.Haircut
                  ? user.Haircut.find((haircut) => haircut.id)?.id
                  : [],
              };
          }
        }),
      );
    }
  }, [user]);

  async function patchUser() {
    const haircut = formData.find((val) => val.id === "haircut")?.value;
    const bust = formData.find((val) => val.id === "brust")?.value;
    const appearance = formData.find((val) => val.id === "appearance")?.value;
    const newData: IRequestPatchUser = {
      // Haircut: haircut ? [haircut] : undefined, FIXME!
      usersAppearances: appearance
        ? appearance.map((id) => ({ appearanceId: id }))
        : undefined,
      model: {
        height: formData.find((val) => val.id === "height")?.value || undefined,
        weight: formData.find((val) => val.id === "weight")?.value || undefined,
        breast: bust ? BUST_SIZE.find((b) => b.id === bust)?.name : undefined,
        description:
          formData.find((val) => val.id === "description")?.value || undefined,
      },
    };
    dispatch(updateUser(newData));
  }

  async function fetchData() {
    setIsLoading(true);
    const appearances: IAppearance[] = await getAppearance();
    const haircuts: THaircut[] = await getHaircuts();
    setFormData((prevData) =>
      prevData.map((item) =>
        item.id === "appearance"
          ? {
              ...item,
              options: appearances.map((appear) => ({
                id: appear.id,
                name: appear.appearance,
              })),
            }
          : item.id === "haircut"
            ? {
                ...item,
                options: haircuts.map((val) => ({
                  id: val.id,
                  name: val.haircut,
                })),
              }
            : item,
      ),
    );

    setIsLoading(false);
  }

  useEffect(() => {
    setUserData();
    fetchData();
  }, [setUserData, user]);

  return (
    <div>
      {isLoading ? (
        <div className={styles.loader}>
          <Loader color="#ac2386" size={60} borderWidth={5} />
        </div>
      ) : (
        <>
          <form className={styles.BlockGeneral}>
            {formData.map((item) => {
              if (item.type === "selectMulti" && item.options) {
                return (
                  <MultiDropdown
                    key={item.id}
                    options={item.options}
                    label={item.label}
                    onChange={(newValue) => handleChange(newValue, item.id)}
                    placeholder={item.placeholder}
                    selectedOptions={item.value}
                  />
                );
              } else if (item.type === "select" && item.options) {
                return (
                  <DropdownTwo
                    key={item.id}
                    name={item.label}
                    setState={(newValue) => handleChange(newValue, item.id)}
                    data={item.options}
                    state={
                      item.options.find(
                        (op) =>
                          op.id === item.value ||
                          (typeof item.value === "string" &&
                            op.name === item.value),
                      )?.name || null
                    }
                    placeholder={item.placeholder}
                  />
                );
              } else if (
                item.type === "password" &&
                typeof item.value === "string"
              ) {
                <InputPassword
                  id={String(item.id)}
                  label={item.label}
                  type={item.type}
                  value={item.value}
                  className={styles.inputField}
                  onChange={(e) => handleChange(e.target.value, item.id)}
                  placeholder="Enter password"
                />;
              } else if (
                item.type !== "select" &&
                item.type !== "password" &&
                item.type !== "textarea"
              ) {
                return (
                  <Input
                    id={String(item.id)}
                    label={item.label}
                    type={item.type}
                    value={item.value}
                    className={styles.inputField}
                    onChange={(e) => handleChange(e.target.value, item.id)}
                    placeholder={item.placeholder}
                  />
                );
              }
            })}
          </form>
          <div className={styles.textareaBlock}>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Beschreibung</label>
              <textarea
                placeholder="Enter beschreibung..."
                value={formData.find((val) => val.id === "description")?.value}
                className={styles.inputField_textarea}
                onChange={(e) => handleChange(e.target.value, "description")} // Assuming 0 is the id for textarea
              ></textarea>
            </div>
          </div>
          <div className={styles.ButtonBlock}>
            <div className={styles.Button}>
              <Button type="button" onClick={patchUser}>
                Edite
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
